<template>
  <div>
    <div>
      <NotificationMessage v-if="showNotification" :message="notificationMessage" :type="notificationType" :duration="5000"/>
    </div>
    <b-row no-gutters>
      <b-col lg="7" md="4">
        <b-card-text class="pt-3 pb-3">
          <div class="titres pr-2" align ="left" >{{JeuRequetesData.nom}}</div>
        </b-card-text>
      </b-col>

      <b-button pill @click.prevent = "handleShowModalRequeteInJeu(JeuRequetesData.idJeuRequetes)" align-self="center"
      title="visualiser les requêtes du jeu" id="voirRequetes" class="nav-link5">requetes <i class="fas fa-list"></i></b-button>

      <b-button pill @click.prevent ="handleShowModalRequeteNotInJeu(JeuRequetesData.idJeuRequetes)"  align-self="center"
      title="ajouter une requête au jeu" id="ajoutRequetes" class="nav-link1">ajouter <i class="fas fa-plus-circle"></i></b-button>

      <b-button pill @click.prevent ="showModalModifierJeu = !showModalModifierJeu;
      showModalRequetesIn=false; showModalRequetesOut=false"  align-self="center" id="modifJeu"
      title="modifier le jeu" class="nav-link4">modifier <i class="fas fa-pencil-alt"></i></b-button>

      <b-button pill type="button" v-on:click ="deleteJeuRequete(JeuRequetesData.idJeuRequetes)"  align-self="center"
      title="supprimer le jeu" id="supprJeu" class="nav-link2">supprimer <i class="fas fa-trash-alt"></i></b-button>
    </b-row>

    <div class ="item">
      <b-col class="mb-2 mt-1 requetes">
        <div class="requete" v-if="showModalRequetesIn!==false">
          <div v-if="requetes.length!==0" style="position:relative; max-height:400px; overflow-y:auto">
            <p bg-variant="light" align="left"
            v-for="requete in requetes"
            v-bind:key="requete.idRequete"
            v-bind:requete="requete" class="mb-2">
              <RequetesInJeu
              :requete="requete"
              :idJeuRequetes="JeuRequetesData.idJeuRequetes"
              class="center">
              </RequetesInJeu>
            </p>
          </div>
          <div v-else-if="loaded" class = "loading">Aucune requête dans ce jeu</div>
          <div class = "loading" v-if="!loaded">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <span class="ml-2">Chargement en cours...</span>
          </div>
        </div>

        <div class="requetenot" id="requeteOut" v-if="showModalRequetesOut!==false">
          <h3 class ="RequeteAjout mt-3 mb-4">Ajouter une ou plusieurs requête(s) au jeu</h3>
          <p class = "dispo" align-self="left">Requêtes Disponibles</p>
          <div v-if="requetesNot.length!==0" style="position:relative; max-height:400px; overflow-y:auto">
            <p bg-variant="light" align="left"
            v-for="requete in requetesNot"
            v-bind:key="requete.idRequete"
            v-bind:requete="requete" class="mb-2">
              <RequetesNotInJeu
              :requete="requete"
              :idjeu="JeuRequetesData.idJeuRequetes"
              :selected ="selected"
              class="center">
              </RequetesNotInJeu>
            </p>
          </div>
          <div class = "loading" v-if="!loaded">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <span class="ml-2">Chargement en cours...</span>
          </div>
          <p class="dispo mt-4" align-self="left">Requêtes séléctionnées</p>
          <div style="position:relative; max-height:400px; overflow-y:auto">
            <p bg-variant="light" align="left"
               v-for="requete in requetesFrom"
               v-bind:key="requete.idRequete"
               v-bind:requete="requete" class="mb-2">
              <RequetesNotInJeu
                  :requete="requete"
                  :idjeu="JeuRequetesData.idJeuRequetes"
                  :selected ="!selected"
                  class="center">
              </RequetesNotInJeu>
            </p>
            </div>

          <b-button pill id="validInsertRequeteFromJeu" type="submit" v-on:click="insertRequetesFromJeu" class="nav-link3 m-2">Valider</b-button>
          <b-button pill  class="nav-link2 m-2" @click="showModalRequetesOut = !showModalRequetesOut" >Annuler</b-button>
        </div>

        <div id="modif" class="requete" v-if="showModalModifierJeu">
              <ModalModifierJeu :idjeu="JeuRequetesData.idJeuRequetes"
              @close="showModalModifierJeu = false" @notification="handleNotification" class="center">
              </ModalModifierJeu>
        </div>

      </b-col>      
    </div>  
  </div>   
</template>

<script>
import { useJeuRequetesFunctions } from '@/composition/JeuRequetes/jeuRequetesList'
import ModalModifierJeu from '@/components/JeuRequetes/ModalModifierJeu.vue'
import RequetesInJeu from '@/components/JeuRequetes/RequetesInJeu.vue'
import RequetesNotInJeu from '@/components/JeuRequetes/RequetesNotInJeu.vue'
import NotificationMessage from "@/components/Notification.vue";

export default {
    name:"JeuRequetesItemAccordion",

    components:{
      NotificationMessage,
      ModalModifierJeu,
      RequetesInJeu,
      RequetesNotInJeu,
    },

    props:{
      JeuRequetesData:{
        type:Object,
        required:true
      },
      selected:{
        type:Boolean,
        default:false
      },
    },

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  setup(props){
    return useJeuRequetesFunctions(props);
  }
};
</script>

<style>

.requetenot{
  border-style: solid;
  border-color: white;
}

.titres{
color: white;
}

.RequeteAjout{
  color:white;
}

.dispo{
  color: white;
  margin-bottom: 0;
  text-align: left;
  padding-left: 10px;
}

.other{
  color: white;
}
.loading{
  color: white;
}
</style>
